import PubSubUtils from '../../utils/pubsub-utils';
import APP_CONSTANTS from '../../constants';

export const unSubscribeExpressLocalActionSubmitEvent = (subscriptionItemName: string) => {
  PubSubUtils.unsubscribe(APP_CONSTANTS.PUB_SUB_EVENTS.EVENT_EXPRESS_LOCALACTION, subscriptionItemName);
};

export const subscribeExpressLocalActionSubmitEvent = (callback: Function, subscriptionItemName: string) => {
  PubSubUtils.subscribe(APP_CONSTANTS.PUB_SUB_EVENTS.EVENT_EXPRESS_LOCALACTION, callback, subscriptionItemName);
};
